module.exports = __webpack_public_path__ + "static/media/Paul Huynh.2d786bd0.jpg";